import { FC } from 'react';
import { AddAlterButton } from '../../../../../../lib/components/Buttons/AddAlterButton';

interface IProps {
	show_content_list: () => void;
}

export const TagsFormFieldContract: FC<IProps> = ({ show_content_list }) => {
	return (
		<section className='flex flex-row items-center pb-4'>
			<Title />
			<AddAlterButton {...{ onClick: show_content_list }} />
		</section>
	);
};

const Title: FC = () => <h1 className='text-lg font-medium mr-6'>Conteúdos</h1>;
